module.exports = __webpack_public_path__ + "img/referral-light.27518d7d.png";